import React, { FC, PropsWithChildren, useEffect, useState } from "react";
import cn from "classnames";
import { popupContainerClass } from "../../shared/getPopupContainer";
import { Button, Hamburger } from "../../components";
import { usePageSize } from "../../hooks";
import stl from "./Top.mobile.module.scss";
import Languages from "./Languages";
import Links from "./Links";
import Socials from "./Socials";
import { useStore } from "effector-react";
import { SettingsEndpoint } from "../../store/endpoints";
import { FiArrowLeft, FiInfo } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { AppConfig } from "../../config";
import Logo from "./Logo";
import ImportantAnnouncement from "./ImportantAnnouncement";

const TopMobile: FC<{
  className?: PropsWithChildren<HTMLDivElement>["className"];
}> = ({ className }) => {
  const { t } = useTranslation(AppConfig.translationFileNames.base);
  const { data: settings } = useStore(SettingsEndpoint.store);

  const pageSizes = usePageSize();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const close = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    let on = true;
    if (pageSizes.md && on) close();
    return () => {
      on = false;
    };
  }, [pageSizes.md]);

  return (
    <>
      <div className={cn(className, stl.block, popupContainerClass)}>
        <div className={stl.topline}>
          <div className={stl.left}>
            <div>
              <Hamburger isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
          </div>
          <div className={stl.center}>
            <Logo imgClass={stl.center__logo} />
          </div>
          <div className={stl.right} />
        </div>

        <div className={cn(stl.popup, { [stl.open]: isOpen })}>
          <div className={stl.popupInner}>
            <Languages />
            <Links vertical />
            <Socials />

            {settings?.website_url && (
              <div>
                <Button
                  variant={"help"}
                  size={"small"}
                  href={settings.website_url}
                  target={"_blank"}
                  rel={"noreferrer"}
                  icon={<FiArrowLeft />}
                >
                  {t("backToWebsite")}
                </Button>
              </div>
            )}

            {settings?.phone && (
              <div>
                <Button
                  variant={"help"}
                  size={"small"}
                  href={`tel:${settings.phone}`}
                  icon={<FiInfo />}
                >
                  {t("callUs.q")}
                  <i style={{ marginLeft: 5 }}>
                    {t("callUs.r")} {settings.phone}
                  </i>
                </Button>
              </div>
            )}
            {settings?.contact_url && (
              <div>
                <Button
                  href={settings.contact_url}
                  target={"_blank"}
                  rel={"noreferrer"}
                  variant={"callToAction"}
                >
                  {t("contact")}
                </Button>
              </div>
            )}
          </div>
        </div>
        <div
          className={cn(stl.overlay, { [stl.open]: isOpen })}
          onClick={close}
        />
      </div>
      <ImportantAnnouncement />
    </>
  );
};

export default TopMobile;
